<template>
  <div class="flex w-full gap-4">
    <button
      v-if="!basketProduct"
      :key="btnKey"
      @click="clicked"
      class="btn btn-primary w-full text-white"
      :disabled="bascetStore.loading"
    >
      В корзину
    </button>
    <div v-else class="w-2/4">
      <button
        :key="btnKey"
        @click="clicked"
        class="btn btn-outline btn-primary w-full bg-white"
        :disabled="bascetStore.loading"
      >
        В корзине (перейти)
      </button>
    </div>
    <div v-if="basketProduct" class="flex-1">
      <ProductBasketCount
        v-if="basketProduct"
        :count="basketProduct.quantity"
        @minus="bascetStore.delBasketProduct(props.productId, 1)"
        @plus="bascetStore.addBasketProduct(props.productId, 1)"
        :loading="bascetStore.loading"
      ></ProductBasketCount>
      <ProductBasketCount
        v-else
        :count="basketCount"
        :loading="bascetStore.loading"
        @minus="minusBascet"
        @plus="bascetStore.addBasketProduct(props.productId, 1)"
      >
      </ProductBasketCount>
    </div>
  </div>
</template>
<script lang="ts" setup>
import ProductBasketCount from '@/components/product/ProductBasketCount.vue'
import { useBasketStore } from '@/stores/basket'
import { computed, ref } from 'vue'

const btnKey = ref(0)

const props = defineProps<{
  productId: string
}>()

const basketCount = ref(1)

const bascetStore = useBasketStore()

const basketProduct = computed(() => {
  return bascetStore.$state.items.find((v) => v.product_id == props.productId)
})

const minusBascet = () => {
  basketCount.value = 1
  btnKey.value++
}

const plusBascet = () => {
  basketCount.value += 1
}

const clicked = () => {
  btnKey.value++
  if (basketProduct.value) {
    bascetStore.toBasket()
    return
  }

  bascetStore.addBasketProduct(props.productId, basketCount.value)
  basketCount.value = 1
}
</script>
